import { HttpClient } from 'shared/libs/http';
import { ApiResponseDto } from 'shared/types';
import { SendEmailJobseekerDto } from './types';

export class SendEmailApiService {
   public static sendEmailToAll(dto: {
      job_id: number;
      subject: string;
      message: string;
      email_address: string;
   }) {
      return HttpClient.post<ApiResponseDto<string>>(
         `/candidates/sendmailToalljobseekers`,
         dto
      );
   }

   public static sendEmailJobseeker(
      dto: SendEmailJobseekerDto,
      params: {
         slug: string;
      }
   ) {
      return HttpClient.post<ApiResponseDto<string>>(
         `/candidates/sendmailjobseeker/${params.slug}`,
         dto
      );
   }
}
